<nav mat-tab-nav-bar dynamicHeight [mat-stretch-tabs]="stretch" attr.role="navigation" [attr.aria-label]="ariaLabel + '. Use left and right keys for navigation.'"
     [tabPanel]="tabPanel">
  @for (route of routes; track route) {
    <a mat-tab-link [routerLink]="'./' + route.url" [active]="active && active.url === route.url" [id]="route.id"
       class="equally-sized-tabs">
      <span class="uppercase nav-tab-label">
        @if (route.labelParts) {
          @for (part of route.labelParts; track $index) {
            <span class="nav-tab-label-part">{{ part }}</span>{{ $last ? '' : ' ' }}
          }
        } @else {
          {{ route.label }}
        }
      </span>
    </a>
  }
</nav>
